import React from 'react'

const LoadingSuccessErrorAlert = ({loading}) => {
    return (
        <>
            {loading.status === "Saving" && (
                <div className="alert alert-primary bg-white small p-2" role="alert">
                <span className="fas fa-circle-notch fa-spin" />
                &nbsp;
                <strong>{loading.message}</strong>
                </div>
            )}
            {loading.status === "Loading" && (
                <div className="alert alert-primary bg-white small p-2" role="alert">
                <span className="fas fa-circle-notch fa-spin" />
                &nbsp;
                <strong>{loading.message}</strong>
                </div>
            )}
            {loading.status === "Error" && (
                <div className="alert alert-danger small p-2" role="alert">
                <span className="fas fa-exclamation-triangle" />
                &nbsp;
                <strong>{loading.message}</strong>
                </div>
            )}
            {loading.status === "Success" && loading.message !== undefined && (
                <div className="alert alert-primary bg-white small p-2" role="alert">
                <span className="far fa-check-circle" />
                &nbsp;
                <strong>{loading.message}</strong>
                </div>
            )}
        </>
    );
}

export default LoadingSuccessErrorAlert